<template>
    <div class="vista-dialog">
        <el-dialog :visible="visible" :title="isCustom ? '编辑客户详情' : '查看客户信息'" destroy-on-close width="1000px" :close-on-click-modal='false'
            :close-on-press-escape='false' @close="closeVisible">
            <div class="vista-form-box">
                <dc-form ref='dcForm' refName="customerForm" :row="addNewMainData" :config="FIELDS" label-width="100px"
                    @data-changed="handleFormDataChange" class="vista-form">
                    <template v-slot:form-append="{ form, itemSetting, rIndex }">
                        <el-form-item :label="itemSetting.label" :prop="itemSetting.prop"
                            :label-width="itemSetting.labelWidth ||'100px'">
                            <el-input
                                v-if="['issues','content'].includes(itemSetting.prop) && isCustom"
                                type="textarea"
                                :disabled= "itemSetting.disabled"
                                :rows="itemSetting.rows"
                                :show-word-limit="itemSetting.showWordLimit"
                                :maxlength="itemSetting.maxlength"
                                placeholder="--"
                                v-model="form[itemSetting.prop]">
                            </el-input>
                            <span v-else-if="['issues','content'].includes(itemSetting.prop) && !isCustom" class="custom-texteare" :title="form[itemSetting.prop]">
                                {{ form[itemSetting.prop] ? form[itemSetting.prop] : '--' }}
                            </span>
                            <span v-else-if="['fdId'].includes(itemSetting.prop)" class="mip-link" @click="toFlowLinkHandle(form)" >
                                {{ form[itemSetting.prop] ? '查看流程流转记录' : '--'}}
                            </span>
                            <span v-else-if="itemSetting.optionsKey" class="custom-span" :title="form[itemSetting.prop]">
                                {{ codesToNames(form[itemSetting.prop],
                                    dictDatas[itemSetting.optionsKey])||'--' }}
                            </span>
                            <span v-else-if="!itemSetting.optionsKey" class="custom-span" :title="form[itemSetting.prop]">
                                {{ (form[itemSetting.prop] || form[itemSetting.prop] === 0) ? form[itemSetting.prop] : '--' }}
                            </span>
                        </el-form-item>
                    </template>
                </dc-form>
                <div class="transfer-log-box" v-if="getListClass.totalData.length > 0 || getListClass.tableLoading">
                    <div class="transfer-log-title">变更日志</div>
                    <table-box :columns="transferLogConfig.columns" :height="400" :rows="getListClass.totalData" :loading="getListClass.tableLoading"
                        :pagination="getListClass.pagination" :index="transferLogConfig.index" :control="false">
                    </table-box>
                    <div class="transfer-log-pagination">
                        <lots-pagination
                            :total="getListClass.pageTotal"
                            :current-page.sync="getListClass.pageNo"
                            :page-size.sync="getListClass.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            @size-change="getListClass.sizeChange"
                            @current-change="getListClass.pageChange" />
                    </div>
                </div>
            </div>

            <span slot="footer">
                <el-button size="mini" @click="closeVisible(false)" v-if="isCustom">取消</el-button>
                <el-button type="primary" size="mini" @click="closeVisible(false)" v-else>关闭</el-button>
                <el-button type="primary" size="mini" @click="confirmHandle" v-if="isCustom">更新</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, computed, getCurrentInstance } from '@vue/composition-api';
import { formConfig, transferLogConfig } from './config.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { updateCustomerVisit, getTransferLogPageApi } from '@mdm/api/customer/customerVisitManage.js';
import { Message } from 'element-ui';
import dcForm from '@/modules/mdm/components/form/Index.vue';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import _ from 'lodash';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc';
export default {
    components: { dcForm, tableBox, lotsPagination },
    props: { },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(_.cloneDeep(formConfig));
        const emit = setupContext.emit;
        const _addNewMainData = { };
        const addNewMainData = ref(_.cloneDeep(_addNewMainData));
        const currentRowData = ref({});
        const FIELDS = computed(() => {
            const isEdit = isCustom.value;
            const _config = _.cloneDeep(formConfig);
            const problemMapping = dictDatas.value['CUSTOMER_PROBLEM_MAPPING'] || {};
            const firstClassCode = currentRowData.value.firstClassProblemCode;
            const secondClassCode = currentRowData.value.secondClassProblemCode;
            const isSecondClassRequired = secondClassCode && problemMapping[secondClassCode] === firstClassCode;
            _config.fields.forEach(item => {
                if (!isEdit) {
                    item.type = 'custom';
                }
                if (item.prop === 'secondClassProblemCode') {
                    item.rule = [{
                        required: isSecondClassRequired,
                        message: '二级问题分类不能为空',
                        trigger: ['change', 'blur']
                    }];
                }
            });
            return _config.fields;
        });

        const handleFormDataChange = ({ data, form, itemSetting }) => {
            addNewMainData.value = Object.assign(addNewMainData.value, form);
        };

        const visible = ref(false);
        const isCustom = ref(false);
        const dictDatas = ref({});

        class TransferLogListClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.relationId = addNewMainData.value.id;
                return condition;
            }
        }

        const getListClass = new TransferLogListClass({
            Api: {
                listApi: getTransferLogPageApi
            }
        });

        const show = async (val, edit) => {
            visible.value = true;
            isCustom.value = edit;
            currentRowData.value = val;
            dictDatas.value = await otherUtils.getDictDataList(config.columns, ['CUSTOMER_VISIT_LEVEL', 'SYS_WM_IN_OR_OUT_CUSTOMER', 'CUSTOMER_VISIT_INFO_STATUS',
                'CUSTOMER_SECOND_CLASS_PROBLEM', 'CUSTOMER_FIRST_CLASS_PROBLEM', 'CUSTOMER_VISIT_MODE', 'CUSTOMER_PROBLEM_MAPPING'
            ]);
            addNewMainData.value = Object.assign({}, _addNewMainData, val);
            if (!isCustom.value) {
                addNewMainData.value.contact = [null, undefined, ''].includes(addNewMainData.value.contact) ? addNewMainData.value.contact : '***';
                addNewMainData.value.contactMobile = [null, undefined, ''].includes(addNewMainData.value.contactMobile) ? addNewMainData.value.contactMobile : '***';
            }
            getListClass.getList();
            setupContext.root.$nextTick(() => {
                setupContext.refs.dcForm.$refs.customerForm.clearValidate();
            });
        };
        const closeVisible = (val = false) => {
            visible.value = val;
        };
        const confirmHandle = () => {
            addNewMainData.value = setupContext.refs.dcForm.form;
            setupContext.refs.dcForm.validateForm().then(async () => {
                const params = addNewMainData.value;
                const problemMapping = dictDatas.value['CUSTOMER_PROBLEM_MAPPING'] || {};
                const firstClassDict = dictDatas.value['CUSTOMER_FIRST_CLASS_PROBLEM'] || {};
                const secondClassDict = dictDatas.value['CUSTOMER_SECOND_CLASS_PROBLEM'] || {};
                const firstClassCode = params.firstClassProblemCode;
                const secondClassCode = params.secondClassProblemCode;
                if (secondClassCode) {
                    if (!secondClassDict.hasOwnProperty(secondClassCode)) {
                        Message.warning('二级问题分类不在预设值范围内');
                        return;
                    }
                    if (problemMapping[secondClassCode] !== firstClassCode) {
                        Message.warning('二级问题分类与一级问题分类不匹配，请检查');
                        return;
                    }
                } else {
                    if (!firstClassDict.hasOwnProperty(firstClassCode)) {
                        Message.warning('一级问题分类不在预设值范围内');
                        return;
                    }
                }
                updateCustomerVisit(params).then(res => {
                    if (res && +res.code === 0) {
                        setupContext.emit('confirm-update');
                        Message.success('更新成功');
                    }
                }).catch(() => {
                    visible.value = false;
                }).finally(() => {
                    visible.value = false;
                });
            });
        };
        const ctx = getCurrentInstance();
        const toFlowLinkHandle = (row) => {
            if (row.fdId) {
                visible.value = false;
                ctx.$router.push('/customerVisitFlow?id=' + row.id);
            }
        };
        return {
            emit,
            config,
            addNewMainData,
            FIELDS,
            visible,
            isCustom,
            dictDatas,
            currentRowData,
            codesToNames: otherUtils.codesToNames,
            toFlowLinkHandle,
            closeVisible,
            confirmHandle,
            handleFormDataChange,
            show,
            transferLogConfig,
            getListClass
        };
    }
};
</script>
<style lang="less" scoped>
.vista-dialog{
    max-height: 80%;
    overflow-y: auto;
}
.vista-form-box{
    max-height: 80%;
    overflow-y: auto;
    height: 555px;
    .custom-texteare{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        word-break: break-all;
        white-space: pre-wrap;
    }
}
.transfer-log-box{
    padding: 0 20px 20px;
    .transfer-log-title{
        font-size: 14px;
        font-weight: 600;
        color: #606266;
        margin-bottom: 10px;
    }
    .transfer-log-pagination{
        margin-top: 10px;
        display: flex;
        justify-content: flex-end;
    }
}
</style>
<style lang="less">
.vista-form-box{
    .el-select{
        width: 100%;
    }
    .el-date-editor{
        width: 100%;
    }
}

</style>
